import axios from 'axios';

// GET /admin/candidates -> [{ id, crn, name, email, discipline, role, sponsor, status }]
export async function getCandidates() {
  try {
    const res = await axios.get('/admin/candidates');
    return res.data.candidates || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

// GET /admin/candidate/:id/passport -> { passport: {...} }
export async function getCandidatePassport(candidateId) {
  try {
    const res = await axios.get(`/admin/candidate/${candidateId}/passport`);
    return res.data.passport || null;
  } catch (error) {
    console.error(error);
    return null;
  }
}
